module.exports = __webpack_public_path__ + "static/media/molde-print.068b109d.svg";